import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';
import { AccordionMarriage } from 'mutation/view-models/registration-marriage';
import { noop } from 'shell/utils/noop';
import FormMarriage from './form';

interface MarriageProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const MarriageComponent = ({ disabled, isEditMode }: MarriageProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<CancelMarriageFormVM>();

  const onFieldMarriageChange = useEventCallback(
    (key: keyof AccordionMarriage, value: AccordionMarriage[keyof AccordionMarriage]) => {
      formContext.setFieldValue('marriage', {
        ...formContext.values.marriage,
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-marriage-content"
        id="panel-person-marriage-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle isEditMode={isEditMode}>Matrimonio</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <FormMarriage
          disabled={disabled}
          values={formContext.values.marriage}
          onChange={onFieldMarriageChange}
          onChangeValues={noop}
          isEditMode={isEditMode}
        />
      </AccordionDetails>
    </Accordion>
  );
};

MarriageComponent.displayName = 'Accordion marriage component';

const Marriage = memo(MarriageComponent);

export default Marriage;
